import * as ActionTypes from "./ActionTypes";
import axios from "axios";


export const setUsers = users => {
	return {
		type: ActionTypes.LOAD_USERS,
		users: users
	};
};

export const setAnalytics = analytics => {
	return {
		type: ActionTypes.LOAD_ANALYTICS,
		analytics: analytics.data
	};
};

/*export const setAnalyticsHours = ana_hours => {
	return {
		type: ActionTypes.LOAD_ANALYTICS_HOURS,
		analytics: ana_hours.data
	};
};

export const setAnalyticsAct = ana_act => {
	return {
		type: ActionTypes.LOAD_ANALYTICS_ACTIVITY,
		analytics: ana_act.data
	};
};

export const setAnalyticsHeat = ana_heat => {
	return {
		type: ActionTypes.LOAD_ANALYTICS_HEAT,
		analytics: ana_heat.data
	};
};*/

export const loadAnalytics = (anarequest) => {
	return dispatch => {

		axios
		.post(
			"http://getupstudio.co/sanofiapi/users/analytics",
			anarequest
		)
			.then(response => {
				dispatch(setAnalytics(response.data));
			})
			.catch(error => {});
	};
};

/*export const loadAnalyticsHours = (anhoursrequest) => {
	return dispatch => {

		axios
		.post(
			"http://getupstudio.co/sanofiapi/users/analytics/hours",
			anhoursrequest
		)
			.then(response => {
				dispatch(setAnalyticsHours(response.data));
			})
			.catch(error => {});
	};
};

export const loadAnalyticsAct = (anactrequest) => {
	return dispatch => {

		axios
		.post(
			"http://getupstudio.co/sanofiapi/users/analytics/activity",
			anactrequest
		)
			.then(response => {
				dispatch(setAnalyticsAct(response.data));
			})
			.catch(error => {});
	};
};

export const loadAnalyticsHeat = (anheatrequest) => {
	return dispatch => {

		axios
		.post(
			"http://getupstudio.co/sanofiapi/users/analytics/heatmap",
			anheatrequest
		)
			.then(response => {
				dispatch(setAnalyticsHeat(response.data));
			})
			.catch(error => {});
	};
};*/

export const loadUsers = token => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
		.get(
			"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/users/",
			{
				headers: { Authorization: AuthStr }
			}
		)
			.then(response => {
				if (response != undefined) {
					var users = response.data;
					dispatch(setUsers(users));
				}
			})
			.catch(error => {});
	};
};

export const loadUsersMonth = token => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
		.get(
			"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/users/month",
			{
				headers: { Authorization: AuthStr }
			}
		)
			.then(response => {
				if (response != undefined) {
					var users = response.data;

					dispatch(setUsers(users));
				}
			})
			.catch(error => {});
	};
};

export const loadUsersWeek = token => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
		.get(
			"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/users/week",
			{
				headers: { Authorization: AuthStr }
			}
		)
			.then(response => {
				if (response != undefined){
					var users = response.data;

				 	dispatch(setUsers(users));
				}
			})
			.catch(error => {});
	};
};


export const createUser = (token, user) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
			.post(
				"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/login/signup",
				{"user":user},
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				if (response != undefined) dispatch(loadUsers(token));
			})
			.catch(error => {});
	};
};



export const deleteUser = (token, iduser) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
		.delete(
			"https://cors-anywhere.herokuapp.com/http://190.105.227.203/sanofiapi/users", {
				params: { id: String(iduser) }
			},
			{
				headers: { Authorization: AuthStr }
			}
		)
			.then(response => {
				if (response != undefined) dispatch(loadUsers(token));
			})
			.catch(error => {});
	};
};



